import React from 'react'
import TabBar from './TabBar'

function Home() {
  return (
    <>
      <TabBar/>
    </>
  )
}

export default Home